import React, { useEffect } from 'react';
import { View, Spacer, HStack, Heading } from 'native-base';
import { TabView, SceneMap, TabBarProps, Route } from 'react-native-tab-view';
import { Dimensions, StatusBar, Animated, Pressable } from 'react-native';

// Assets
import { theme } from '@breakroom-nx/assets';
import { MegaphoneIcon } from '@heroicons/react/24/solid';

// Components
import { IconButton, FeedbackScrollView, Ring } from '../../';
import { AppFeedbackType } from '@breakroom-nx/classes';
import {
  toggleForm,
  useAppDispatch,
  useAppSelector,
  getFeedbackFormState,
} from '@breakroom-nx/redux';

const initialLayout = { width: Dimensions.get('window').width };

// Tab Routes
const FirstRoute = () => {
  return <FeedbackScrollView type={AppFeedbackType.Updates} />;
};
const SecondRoute = () => {
  return <FeedbackScrollView type={AppFeedbackType.Suggestions} />;
};

export function FeedbackContainer() {
  const dispatch = useAppDispatch();
  const [index, setIndex] = React.useState(0);
  const formOpen = useAppSelector(getFeedbackFormState);
  const [routes] = React.useState([
    { key: 'first', title: 'Updates' },
    { key: 'second', title: 'Feedback' },
  ]);

  function toggleFeedbackForm() {
    dispatch(toggleForm());
  }

  const renderScene = SceneMap({
    first: FirstRoute,
    second: SecondRoute,
  });

  useEffect(() => {
    // console.log('Feedback Container Active');
    // return () => {
    //   console.log('Feedback Container Unmounted');
    // };
  }, []);

  const renderTabBar = (props: TabBarProps<Route>) => {
    return (
      <HStack flexDirection="row" alignItems={'center'} p={10}>
        {props.navigationState.routes.map((route: Route, i: number) => {
          const color =
            index === i ? theme.colors.white : theme.colors.surface[400];

          return (
            <View pr={5} alignItems={'flex-end'} key={route.key}>
              <Pressable
                onPress={() => {
                  setIndex(i);
                }}
              >
                <Animated.View>
                  <Heading
                    alignSelf={'flex-end'}
                    fontSize={28}
                    lineHeight={30}
                    style={{ color }}
                  >
                    {route.title}
                  </Heading>
                </Animated.View>
              </Pressable>
            </View>
          );
        })}
        <Spacer />

        <Ring hidden={!formOpen || index !== 1}>
          {index === 1 ? (
            <IconButton
              onPress={toggleFeedbackForm}
              icon={
                <MegaphoneIcon
                  style={{
                    height: '20px',
                    width: '20px',
                    color: theme.colors.primary[400],
                  }}
                />
              }
              tooltipText={'Submit Feedback'}
            />
          ) : null}
        </Ring>
      </HStack>
    );
  };

  return (
    <TabView
      navigationState={{ index, routes }}
      renderScene={renderScene}
      renderTabBar={renderTabBar}
      onIndexChange={setIndex}
      initialLayout={initialLayout}
      style={{
        marginTop: StatusBar.currentHeight,
        height: '100%',
      }}
    />
  );
}

export default React.memo(FeedbackContainer);
